import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component }  from 'react';
import {Tab, Row, Nav, Col, Tabs, Accordion} from "react-bootstrap";
import {slugify} from "./UpdateProductModal";
import { Trash } from 'react-feather';
import { apiFetch, API, getMarket } from "../../services/api";

function buildSelectedGlobalProduct(selectedGlobalProduct) {
    var returnedProducts = []
    if (selectedGlobalProduct.products && selectedGlobalProduct.products.length > 0) {
        selectedGlobalProduct.products.map(product => {
            returnedProducts.push(
                {
                    name: product.name,
                    headCategory: product.headCategory,
                    shortURL: product.shortURL,
                }
            )
        })
    }
    selectedGlobalProduct.products = returnedProducts
    return selectedGlobalProduct
}

export default class AddLandingPageGlobalProductModal extends Component {
     constructor(props) {
        super(props);
        this.state = {
            homeAppeareanceImg: "",
            homeSponsoredAppearanceImg: "",
            newDeclination: {
                name : "",
                image: "",
                link: "",
                metaTitle: "",
                metaDescription: "",
            },
            numberOfNewDeclination: 1,
            numberOfCharMetaTitle: 0,
            numberOfCharMetaDescription:0,
        };
        this.uploadHomeAppearanceImg = this.uploadHomeAppearanceImg.bind(this);
        this.uploadHomeSponsoredAppearanceImg = this.uploadHomeSponsoredAppearanceImg.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

   handleClose = () => {
        this.props.selectedLandingPage.language = getMarket()
        return apiFetch(API.back + '/landing-page-global-product', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildSelectedGlobalProduct(this.props.selectedLandingPage))
    })
    .then(async response =>
        await sleep(2000).then(
            this.props.closeModal,
            window.location.reload(false)
        ),
    )
    .catch( err =>
        console.log(err)
    );
    };

    uploadHomeAppearanceImg(e, slide) {
        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            fetch('https://back-api.therunningcollective.fr/upload-file', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "landing-page-brands/"+fileName
                })}).then((res) =>
            res.json().then( result =>{
                slide.backgroundImage = result.message
                sleep(1000)
                this.setState({homeAppeareanceImg:  result.message});
            }))}
    }

    uploadHomeSponsoredAppearanceImg(e, slide) {
        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            fetch('https://back-api.therunningcollective.fr/upload-file', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "landing-page-brands/"+fileName
                })}).then((res) =>
            res.json().then( result =>{
                slide.sponsoredImage = result.message
                sleep(1000)
                this.setState({homeAppeareanceImg:  result.message});
            }))}
    }

    addNewGlobalProductDeclinaison(declinaiton){
        if (!declinaiton.categories){
            declinaiton.categories = []
        }
        declinaiton.categories.push({
            name: this.state.newDeclinaisonGlobalProductName,
            content: this.state.newDeclinaisonGlobalProductUrl
        })
        this.setState({newDeclinaisonGlobalProductName: ""})
        this.setState({newDeclinaisonGlobalProductUrl: ""})
    }

    removeGlobalProductDeclinaison(declinaiton, name){
        let list = declinaiton.categories.filter((category, index) => category.name !== name)
        declinaiton.categories = list
        this.setState({newDeclinaisonGlobalProductName: ""})
        this.setState({newDeclinaisonGlobalProductUrl: ""})
    }

    addNewGlobalProductLink(declinaiton){
        if (!declinaiton.links){
            declinaiton.links = []
        }
        declinaiton.links.push({
            name: this.state.newDeclinaisonGlobalProductLinkName,
            content: this.state.newDeclinaisonGlobalProductLinkUrl
        })
        this.setState({newDeclinaisonGlobalProductLinkName: ""})
        this.setState({newDeclinaisonGlobalProductLinkUrl: ""})
    }

    removeGlobalProductLink(declinaiton, name){
        let list = declinaiton.links.filter((link, index) => link.name !== name)
        declinaiton.links = list
        this.setState({newDeclinaisonGlobalProductLinkName: ""})
        this.setState({newDeclinaisonGlobalProductLinkUrl: ""})
    }

    render(){

        return(
            <Modal
                show={this.props.isOpen}
                onHide={this.props.closeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter une landing page d'une franchise produit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <Row>
                            <Col sm={3}>
                                <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                        <Nav.Link eventKey="first">Informations générales</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="why">Pourquoi choisir ce produits ?</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="links">Liens utiles</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="third">SEO </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col sm={9}>
                            <Row>
                                <Col>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first">
                                            <Form.Group >
                                                <Form.Label>Slug : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => this.props.selectedLandingPage.slug = e.target.value} defaultValue={this.props.selectedLandingPage.slug ? this.props.selectedLandingPage.slug : slugify(this.props.selectedLandingPage.title)} placeholder="nike"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Marque : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => this.props.selectedLandingPage.brand = e.target.value} defaultValue={this.props.selectedLandingPage.brand} placeholder="Ex : nike"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Titre : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => this.props.selectedLandingPage.title = e.target.value} defaultValue={this.props.selectedLandingPage.title} placeholder="Ex : Nike"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Description : </Form.Label>
                                                <Form.Control  as="textarea" rows={4} onChange={(e) => this.props.selectedLandingPage.description = e.target.value} defaultValue={this.props.selectedLandingPage.description} placeholder="Ex : Cette page..."/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Image de couverture : </Form.Label>
                                                <Form.File
                                                    id="custom-first-img-translate-html"
                                                    label="Ajouter une image"
                                                    data-browse="Ajouter"
                                                    onChange= {(e) => {this.uploadHomeAppearanceImg(e, this.props.selectedLandingPage)}}
                                                    custom
                                                />
                                                {this.props.selectedLandingPage.backgroundImage ?
                                                    <img className="imgToDisplay" alt="Couverture actuelle" src={this.props.selectedLandingPage.backgroundImage}/>
                                                    :
                                                    null
                                                }
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Image sponsorisée : </Form.Label>
                                                <Form.File
                                                    id="custom-first-img-translate-html"
                                                    label="Ajouter une image"
                                                    data-browse="Ajouter"
                                                    onChange= {(e) => {this.uploadHomeSponsoredAppearanceImg(e, this.props.selectedLandingPage)}}
                                                    custom
                                                />
                                                {this.props.selectedLandingPage.sponsoredImage ?
                                                    <img className="imgToDisplay" alt="Couverture actuelle" src={this.props.selectedLandingPage.sponsoredImage}/>
                                                    :
                                                    null
                                                }
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Produits éligibles : </Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    multiple
                                                    onChange={(e) => {this.props.selectedLandingPage.products = [...e.target.selectedOptions].map(o => this.props.availableProducts.find(product =>  product.name === o.value))}}
                                                    defaultValue={getSelectedItems(this.props.selectedLandingPage.products)}
                                                >
                                                    {this.props.availableProducts.map((product, index) =>
                                                        <option key={index} value={product.name}>{product.name}</option>
                                                    )}
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Titre de l'espace "Pourquoi" : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => this.props.selectedLandingPage.toKnow.name = e.target.value} defaultValue={this.props.selectedLandingPage.toKnow.name} placeholder="Ex : Ce qu'il faut savoir sur la collection Nike Air Zoom Pegasus..."/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Articles liés au produit : </Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    multiple
                                                    onChange={(e) => this.props.selectedLandingPage.posts = [...e.target.selectedOptions].map(o => o.value)}
                                                    defaultValue={this.props.selectedLandingPage.posts}
                                                >
                                                    {(this.props.availablePosts) ? this.props.availablePosts.map(post =>
                                                        <option key={post.slug} value={post.slug}>{post.title.rendered}</option>
                                                    ) : <option>Aucun article disponible</option>}
                                                </Form.Control>
                                            </Form.Group>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="why">
                                            <Form.Group >
                                                <Form.Label>Sections : </Form.Label>
                                                <Accordion>
                                                        <Form>
                                                            {this.props.selectedLandingPage.toKnow.categories && this.props.selectedLandingPage.toKnow.categories.map(category =>(
                                                                <Form.Group as={Row} key={category.name}>
                                                                    <Form.Label column sm="4">
                                                                        <Form.Control type="text" onChange={(e) => category.name = e.target.value} defaultValue={category.name} placeholder="Pourquoi choisir..."/>
                                                                    </Form.Label>
                                                                    <Col sm="7" className="retailerUrl">
                                                                        <Form.Control as="textarea" rows={4} onChange={(e) => category.content = e.target.value} defaultValue={category.content} placeholder="Blablabla"/>
                                                                    </Col>
                                                                    <Col sm="1" className="retailerUrl">
                                                                        <Button variant="secondary" onClick={() => this.removeGlobalProductDeclinaison(this.props.selectedLandingPage.toKnow, category.name)}>
                                                                            <Trash size={10}/>
                                                                        </Button>
                                                                    </Col>

                                                                </Form.Group>
                                                            ))}
                                                            <Form.Group as={Row}>
                                                                <Form.Label column sm="4">
                                                                    <Form.Control type="text" onChange={(e) => this.setState({newDeclinaisonGlobalProductName : e.target.value})} placeholder="Pourquoi choisir..."/>
                                                                </Form.Label>
                                                                <Col sm="7" className="retailerUrl">
                                                                    <Form.Control as="textarea" rows={4}  placeholder="Elles sont..."
                                                                                    onChange={(e) => this.setState({newDeclinaisonGlobalProductUrl : e.target.value}) }
                                                                    />
                                                                </Col>
                                                                <Col sm="1" className="retailerUrl">
                                                                    <Button variant="secondary" onClick={() => this.addNewGlobalProductDeclinaison(this.props.selectedLandingPage.toKnow)}>+</Button>
                                                                </Col>
                                                            </Form.Group>
                                                        </Form>
                                                </Accordion>
                                            </Form.Group>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="links">
                                            <Form.Group >
                                                <Form.Label>Liens utiles : </Form.Label>
                                                <Accordion>
                                                        <Form>
                                                            {this.props.selectedLandingPage.links && this.props.selectedLandingPage.links.map(link =>(
                                                                <Form.Group as={Row} key={link.name}>
                                                                    <Form.Label column sm="4">
                                                                        <Form.Control type="text" onChange={(e) => link.name = e.target.value} defaultValue={link.name} placeholder="Nike Ultrafly"/>
                                                                    </Form.Label>
                                                                    <Col sm="7" className="retailerUrl">
                                                                        <Form.Control type="text" onChange={(e) => link.content = e.target.value} defaultValue={link.content} placeholder="https://...."/>
                                                                    </Col>
                                                                    <Col sm="1" className="retailerUrl">
                                                                        <Button variant="secondary" onClick={() => this.removeGlobalProductLink(this.props.selectedLandingPage, link.name)}>
                                                                            <Trash size={10}/>
                                                                        </Button>
                                                                    </Col>

                                                                </Form.Group>
                                                            ))}
                                                            <Form.Group as={Row}>
                                                                <Form.Label column sm="4">
                                                                    <Form.Control type="text" onChange={(e) => this.setState({newDeclinaisonGlobalProductLinkName : e.target.value})} placeholder="Nike Ultrafly"/>
                                                                </Form.Label>
                                                                <Col sm="7" className="retailerUrl">
                                                                    <Form.Control type="text"  placeholder="https://...." onChange={(e) => this.setState({newDeclinaisonGlobalProductLinkUrl : e.target.value}) }
                                                                    />
                                                                </Col>
                                                                <Col sm="1" className="retailerUrl">
                                                                    <Button variant="secondary" onClick={() => this.addNewGlobalProductLink(this.props.selectedLandingPage)}>+</Button>
                                                                </Col>
                                                            </Form.Group>
                                                        </Form>
                                                </Accordion>
                                            </Form.Group>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="third">
                                            <Form.Group >
                                                <Form.Label>Balise Titre : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => {this.props.selectedLandingPage.metaTitle = e.target.value; this.setState({numberOfCharMetaTitle: e.target.value})}} defaultValue={this.props.selectedLandingPage.metaTitle} placeholder="Ex : Nike"/>
                                                <Form.Text className="text-muted">
                                                    {this.state.numberOfCharMetaTitle ? this.state.numberOfCharMetaTitle.length : this.props.selectedLandingPage.metaTitle.length} des 70 caractères utilisés (recommandé)
                                                </Form.Text>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Meta Description : </Form.Label>
                                                <Form.Control as="textarea" rows={4} onChange={(e) => {this.props.selectedLandingPage.metaDescription = e.target.value; this.setState({numberOfCharMetaDescription: e.target.value})}} defaultValue={this.props.selectedLandingPage.metaDescription} placeholder="Cette marque est ..."/>
                                                <Form.Text className="text-muted">
                                                    {this.state.numberOfCharMetaDescription ? this.state.numberOfCharMetaDescription.length : this.props.selectedLandingPage.metaDescription.length} des 160 caractères utilisés (recommandé)
                                                </Form.Text>
                                            </Form.Group>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" type="cancel" onClick={this.props.closeModal}>
                        Annuler
                    </Button>
                    <Button variant="primary" type="submit" onClick={this.handleClose}>
                        Valider
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export function sleep(time){
    return new Promise((resolve)=>setTimeout(resolve,time)
    )
}

function getSelectedItems(items){
    var arrayToReturn = []

    if (items) {
        items.map(item =>(
                arrayToReturn.push(item.name)
            )
        )
    }

    return arrayToReturn
}